/*
Auto-generated by: https:github.com/pmndrs/gltfjsx
author: ¡Jacques (https:sketchfab.com/iJacques)
license: CC-BY-4.0 (http:creativecommons.org/licenses/by/4.0/)
source: https:sketchfab.com/3d-models/vending-machine-f537e142a592428d85ca7a940be221d3
title: Vending Machine
*/

 import React, { useRef } from 'react'
 import { useGLTF } from '@react-three/drei'
import SelectToZoom from './zoomonclick'
import { Bounds } from '@react-three/drei'

 export default function VendingMach({ ...props }) {
   const group = useRef()
   const { nodes, materials } = useGLTF('/vendingMach.glb')
   return (
     <>
    
     <group ref={group} {...props} dispose={null}>
       <group rotation={[-Math.PI / 2, 0, 0]}>
         <group rotation={[Math.PI / 2, 0, 0]}>
           <group position={[0.46, 1.28, -0.15]} rotation={[-0.34, -0.5, 0.16]} scale={[0.19, 0.15, 0.19]}>
             <mesh geometry={nodes.Object_9.geometry} material={materials.Sweets} />
           </group>
           <group position={[0.39, 2.91, 0.27]} scale={0.24}>
             <mesh geometry={nodes.Object_11.geometry} material={materials.Sweets} />
           </group>
           <mesh geometry={nodes.Object_4.geometry} material={materials.Machine} />
           <mesh geometry={nodes.Object_5.geometry} material={materials.Plates} />
           <Bounds clip observe margin={1.2}>
          <SelectToZoom>
           <mesh geometry={nodes.Object_7.geometry} material={materials.Glass} />
          </SelectToZoom>
          </Bounds>
         </group>
       </group>
     </group>
     </>
   )
 }

 useGLTF.preload('/vendingMach.glb')
